export default __webpack_public_path__ + "static/media/fb.c81ae6ee.png";